import { FRONT_WARNING } from '@app/constants';
import type { NUtils } from '@app/types';

import type { BaseOptionType } from 'antd/es/select';

export const correctTimeInterval: NUtils.CorrectTimeInterval = ({
  inputStart,
  inputEnd,
  cbToSaveStartValue,
  cbToSaveEndValue,
  cbToSaveBothValues,
  showNotification,
}): void => {
  let outputStartInMs: number | null = null;
  let outputEndInMs: number | null = null;
  let isIncorrectInterval = false;

  let checkedOutputStart: BaseOptionType = inputStart;
  let checkedOutputEnd: BaseOptionType = inputEnd;

  const showErr = (err: string): void => showNotification(err, FRONT_WARNING);

  if (!inputStart || !inputEnd) return;

  if (typeof inputStart !== typeof inputEnd)
    return showErr('Типы границ интервала не должны отличаться');

  const [startInputHours, startInputMinutes] = inputStart.label.split(':');
  const [endInputHours, endInputMinutes] = inputEnd.label.split(':');

  outputStartInMs = +startInputHours * 60 * 60 + +startInputMinutes * 60;
  outputEndInMs = +endInputHours * 60 * 60 + +endInputMinutes * 60;

  const hasNegativeDiff =
    outputEndInMs && outputStartInMs && outputEndInMs - outputStartInMs < 0;

  if (hasNegativeDiff) {
    isIncorrectInterval = true;
  }

  if (!isIncorrectInterval) return;

  checkedOutputStart = inputEnd;
  checkedOutputEnd = inputStart;

  const hasLogicToSaveNewInterval =
    (cbToSaveStartValue && cbToSaveEndValue) || cbToSaveBothValues;
  const hasUnusedLogic =
    cbToSaveBothValues && (cbToSaveStartValue || cbToSaveEndValue);

  if (!hasLogicToSaveNewInterval)
    return showErr('Отсутствует логика для автозамены интервала времени');

  if (hasUnusedLogic)
    return showErr(
      'Передана неиспользуемая логика сохранения интервала времени'
    );

  if (cbToSaveStartValue && cbToSaveEndValue) {
    cbToSaveStartValue(checkedOutputStart);
    cbToSaveEndValue(checkedOutputEnd);
  }

  if (cbToSaveBothValues) {
    cbToSaveBothValues([checkedOutputStart, checkedOutputEnd]);
  }
};
